<app-users-listing [enableMainBtn]="true" [titleMainBtn]="'Aggiungi Genitore'" [type]="type"
  [linkMainBtn]="'/nuovo-utente'" [linkMainBtnQueryParams]="{type: type}">
</app-users-listing>